import { registerCheckoutBlock } from '@woocommerce/blocks-checkout';
import { ServicePointSelectorBlock } from './block';
import metadata from './block.json';
import './style/style.scss';

registerCheckoutBlock({
  metadata,
  component: ServicePointSelectorBlock,
});
